import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import { renderDeviceIcon } from "../../../Templates/functions";

const useStyles = makeStyles((theme) => ({
    formControl: {
        marginLeft: '.5em',
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: 0,
    },
}));

export default function DropDown({selection, selectOption, options}) {
    const classes = useStyles();

    const handleChange = (event) => {
        let value = event.target.value;
         selectOption(value.toLowerCase());
    };

    return (
        <FormControl className={classes.formControl}>
            <Select
                value={selection}
                onChange={handleChange}
                displayEmpty
                className={classes.selectEmpty}
                inputProps={{ "aria-label": "Without label" }}
            >
                {options.map((option, index) => 
                <MenuItem value={option} key={index}>{
                    <Fragment>
                        <p> {option}</p>
                        <div style={{marginLeft: '.25em'}}>{renderDeviceIcon(option.toLowerCase())}</div>
                    </Fragment>
                    }
                </MenuItem>)}
            </Select>
            <FormHelperText>{renderDeviceIcon(selection)}</FormHelperText>
        </FormControl>
    );
}